<template>
  <div class="Page Museum">
    <keep-alive>
      <Introduction v-if="slugIsBefore('pan') || slugIsIn(['monde', 'monde:1', 'monde:2'])"/>
    </keep-alive>
    <Instructions v-if="$route.params.slug == 'instructions'"/>
    <!-- <Jeu1 v-if="slugIsIn(['3','writing:1', '4', '13', 'writing:2', '4:bis']) && oeuvre"/> -->
    <!-- <Jeu2 v-if="slugIsIn(['9', '14', '15', 'emotions:1', 'emotions:2' ]) && oeuvre"/> -->
    <Inventory  v-if="slugIsBefore('defi3')"/>
    <Defi1 v-if="slugIsIn(['3', 'defi1:1', 'defi1:2']) && oeuvre"/>
    <Defi2 v-if="slugIsIn(['15', 'defi2:1', 'defi2:2', 'defi2:3' ]) && oeuvre"/>
    <Defi3 v-if="slugIsIn(['31', '32', 'defi3', '33' ]) && oeuvre"/>
    
    <keep-alive>
      <Voice v-if="isVoice" />
    </keep-alive>
  </div>
</template>

<script>

import Introduction from '@/components/introduction/Introduction'
import Instructions from '@/components/instructions/Instructions'
import Jeu1 from '@/components/jeu1/Jeu1'
import Jeu2 from '@/components/jeu2/Jeu2'
import Inventory from '@/components/inventory/Inventory'
import Voice from '@/components/voice/Voice'
import Defi1 from '@/components/defis/Defi1'
import Defi2 from '@/components/defis/Defi2'
import Defi3 from '@/components/defis/Defi3'

export default {
  name: 'Museum',
  components: { Introduction, Instructions, Jeu1, Jeu2, Inventory, Voice, Defi1, Defi2, Defi3 },
  computed: { loaded() { return this.$store.getters['loader/loaded'] } }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Museum
  display block
</style>



// WEBPACK FOOTER //
// src/pages/museum/Museum.vue